import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-21e569e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "Dynamic:  ✅", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "FEC:      ✅", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "Hashtree: ✅", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Estimate COW Size: ", -1))
const _hoisted_12 = { key: 4 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Postinstall Script: ", -1))
const _hoisted_14 = { class: "toggle" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Old Partition Size: ", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Old Partition Hash: ", -1))
const _hoisted_20 = { class: "hex" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " New Partition Size: ", -1))
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " New Partition Hash: ", -1))
const _hoisted_24 = { class: "hex" }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Version: ", -1))
const _hoisted_27 = { key: 4 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Version: ", -1))
const _hoisted_29 = { class: "toggle" }
const _hoisted_30 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OperationDetail = _resolveComponent("OperationDetail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", {
      class: _normalizeClass({ 'new-partition': !_ctx.partition.oldPartitionInfo })
    }, _toDisplayString(_ctx.partition.partitionName), 3),
    (_ctx.isDynamicPartition)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.isFECEnabled)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.isHashtreeEnabled)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true),
    (_ctx.partition.estimateCowSize)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.partition.estimateCowSize) + " Bytes ", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.partition.postinstallPath)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
          _hoisted_13,
          _createTextVNode(" " + _toDisplayString(_ctx.partition.postinstallPath), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("h4", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle('showInfo'))),
        class: _normalizeClass({ active: _ctx.showInfo, inactive: !_ctx.showInfo })
      }, " Partition Infos ", 2),
      (_ctx.showInfo)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
            (_ctx.partition.oldPartitionInfo)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(_ctx.partition.oldPartitionInfo.size) + " Bytes ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.partition.oldPartitionInfo)
              ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.octToHex(_ctx.partition.oldPartitionInfo.hash, false, 16)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _hoisted_21,
              _createTextVNode(" " + _toDisplayString(_ctx.partition.newPartitionInfo.size) + " Bytes ", 1)
            ]),
            (_ctx.partition.newPartitionInfo.hash)
              ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.octToHex(_ctx.partition.newPartitionInfo.hash, false, 16)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.partition.version)
              ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                  _hoisted_26,
                  _createTextVNode(" " + _toDisplayString(_ctx.partition.version), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.readableTimestamp)
              ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                  _hoisted_28,
                  _createTextVNode(" " + _toDisplayString(_ctx.readableTimestamp), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("h4", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle('showOPs'))),
        class: _normalizeClass({ active: _ctx.showOPs, inactive: !_ctx.showOPs })
      }, " Total Operations: " + _toDisplayString(_ctx.partition.operations.length), 3),
      (_ctx.showOPs)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partition.operations, (operation) => {
              return (_openBlock(), _createElementBlock("li", {
                key: operation.dataSha256Hash
              }, [
                _createVNode(_component_OperationDetail, {
                  operation: operation,
                  mapType: _ctx.opType.mapType
                }, null, 8, ["operation", "mapType"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}